import React from "react";
import cn from "classnames";
import styles from "./Team.module.sass";
import Subscription from "../../../components/Subscription";
import Image from "../../../components/Image";

const Team = () => {
  return (
    <div className={styles.team}>
      <div className={cn("container", styles.container)}>
        <div className={styles.col}>
          <div className={styles.preview}>
            <Image
              srcSet="/images/zova/team@2x.jpg"
              srcSetDark="/images/zova/team@2x.jpg"
              src="/images/zova/team.jpg"
              srcDark="/images/zova/team.jpg"
              alt="Download bg"
            />
          </div>
        </div>
        <div className={styles.col}>
          <div className={styles.wrap}>
            <h1 className={cn("h1", styles.title)}>
              About Us
            </h1>
            <div className={styles.text}>
              We are a passionate team of MDs, Pharmacists, Biotechnologists, Data Scientists, 
              and Researchers united by a shared vision: making longevity science affordable, accessible, 
              and understandable for a wider audience. We are committed to keeping our approach 
              science-driven and personalized for every individual.
              <br/><br/>
              If you're IN, let's shape this future together.
            </div>
            <Subscription
              className={styles.subscription}
              placeholder="Enter your email"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Team;
